<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    if (sessionStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    } 
    window.addEventListener("beforeunload",()=>{
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f8f8f8 url(../static/loginBg.jpg) no-repeat 0 0;
  background-size: cover;
  height:100%;
}
.backTop {
	width: 28px;
  height: 46px;
  background: url('assets/back_top.png') no-repeat left top;
	background-size: cover;
	position: fixed;
	right: 30px;
	bottom: 30px;
	cursor: pointer;
	display: block;
}
.backTop:hover {
  width: 28px;
  height: 46px;
  background: url('assets/back_top.png') no-repeat right top;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/App.vue